/* sm-vs-barmmerki.js - the name badge line (Nafnaskilti a barm) on the one page kit (adapter 'barmmerki').
   Samraeming L5 (2026-09-29): the old page sm-barmmerki.js moved onto sections/sm-vel.liquid. The engine is
   assets/sm-barm-vel.js (window.SMBarm), loaded unchanged; the looks come from assets/sm-barm-snidmat.json.
   Steps (template block order): Snid (look tiles drawn by the engine) -> Litur (kit option tiles, drawn here)
   -> Staerd (size tiles on one scale) -> Texti (name, line under the name) -> Logo eda takn -> Logo (sm-skra,
   shown only for Logo) -> Festing -> Rammi (kit block, one score line on every look, default on) -> Magn ->
   Athugasemd til okkar -> traust.
   Option 3 of the product holds logo and fastening together ("Logo og festing"): this adapter picks the
   variant itself (afbrigdi) from the colour the kit holds, its size and the two steps.
   Cart properties keep today's keys and order (Snid, Nafn, Texti fyrir nedan nafn, Takn, Rammi, Festing,
   Athugasemdir vid pontun); Rammi is now Med ramma | An ramma. Production stays the engine's JSON record
   (_framleidsla), with the frame in it. No customer text lives here: every word comes from
   snippets/sm-vl-barmmerki.liquid (ctx.vel.ord) or the template (adapter_stillingar).
   ES5, ASCII only. */
(function () {
  'use strict';
  function B() { return window.SMBarm; }
  function has(o, k) { return Object.prototype.hasOwnProperty.call(o, k); }
  function trim(t) { return String(t == null ? '' : t).replace(/^\s+|\s+$/g, ''); }
  function esc(t) { return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function thus(n) { return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
  function kr(a) { var n = Math.round((Number(a) || 0) / 100); return (n < 0 ? '-' : '') + thus(Math.abs(n)) + ' kr.'; }
  function munurKr(a) { return (a > 0 ? '+' : '-') + thus(Math.round(Math.abs(a) / 100)) + ' kr.'; }
  function mal(v) { return String(v || '').replace(/\s+x\s+/i, ' \u00d7 '); }
  function tx(o) { return !o ? '' : typeof o === 'string' ? o : (o.is || ''); }
  var TAKN_RE;
  try { TAKN_RE = new RegExp('[\\p{Extended_Pictographic}\\u{1F1E6}-\\u{1F1FF}\\u{1F3FB}-\\u{1F3FF}\\u{E0020}-\\u{E007F}\\u20E3\\uFE0E\\uFE0F\\u200D]', 'gu'); }
  catch (e) { TAKN_RE = /[\uD83C-\uDBFF][\uDC00-\uDFFF]|[\u2190-\u21ff\u2300-\u23ff\u2460-\u24ff\u25a0-\u27bf\u2900-\u297f\u2b00-\u2bff\u3030\u303d\u3297\u3299\u20e3\ufe0e\ufe0f\u200d]/g; }

  /* ---------- state the adapter keeps (the kit holds colour, frame, quantity and notes) ---------- */
  var CTX = null;
  var ST = { snid: '', staerd: '', lt: 'ekkert', takn: null, festing: 'engin', nafn: '', titill: '', anTitils: false,
    logo: null, logoSkra: null, logoNr: 0, logoSkb: '', snert: false, ath: { nafn: '', titill: '' } };
  var SNID = {}, LISTI = [], TILBUID = false, HLADID = null;

  function V() { return (CTX && CTX.vel) || {}; }
  function ORD() { return V().ord || {}; }
  function t(k, b) { var s = ORD()[k]; s = s == null ? '' : String(s); if (b) s = s.replace(/\{(\w+)\}/g, function (m, n) { return b[n] != null ? String(b[n]) : m; }); return s; }
  function S() { return (CTX && CTX.stillingar) || {}; }

  /* ---------- the product's options by role and position (never by option text) ---------- */
  function hlutverk() { return S().hlutverk || ['litur', 'staerd', 'vidbot']; }
  function kodar(h) { return (S().kodar || {})[h] || []; }
  function stadur(h) { return hlutverk().indexOf(h); }
  function valkostir() { return (CTX && CTX.gogn && CTX.gogn.valkostir) || []; }
  /* shop value code (kit) of role h's value k, and the other way round */
  function shopKodi(h, k) {
    var i = stadur(h), j = kodar(h).indexOf(k), o = valkostir()[i];
    return i < 0 || j < 0 || !o || !o.gildi[j] ? null : String(o.gildi[j].kodi);
  }
  function hlutKodi(h, shop) {
    var i = stadur(h), o = valkostir()[i], j;
    if (i < 0 || !o) return null;
    for (j = 0; j < o.gildi.length; j++) if (String(o.gildi[j].kodi) === String(shop)) return kodar(h)[j] || null;
    return null;
  }
  function kodarOk() {
    var ok = true;
    hlutverk().forEach(function (h, i) { var o = valkostir()[i]; if (!o || o.gildi.length !== kodar(h).length) ok = false; });
    return ok && hlutverk().length === valkostir().length;
  }
  function afbrigdin() { return (CTX && CTX.gogn && CTX.gogn.afbrigdi) || []; }
  function vidbot(lt, festing) { return (lt === 'logo' ? 'ja' : 'nei') + '-' + festing; }
  /* the variant of a choice: { litur (shop code), staerd, lt, festing } */
  function finna(k) {
    if (!kodarOk()) return null;
    var want = [], i, a, j, ok;
    hlutverk().forEach(function (h, p) {
      want[p] = h === 'litur' ? k.litur : h === 'staerd' ? shopKodi('staerd', k.staerd) : h === 'vidbot' ? shopKodi('vidbot', vidbot(k.lt, k.festing)) :
        h === 'logo' ? shopKodi('logo', k.lt === 'logo' ? 'ja' : 'nei') : h === 'festing' ? shopKodi('festing', k.festing) : null;
    });
    var A = afbrigdin();
    for (i = 0; i < A.length; i++) {
      a = A[i]; ok = true;
      for (j = 0; j < want.length; j++) if (want[j] == null || String(a.o[j]) !== String(want[j])) { ok = false; break; }
      if (ok) return a;
    }
    return null;
  }
  function liturShop(s) { var p = stadur('litur'); return s && s.kodar && p >= 0 ? s.kodar[p] : null; }
  function liturAf(s) { return hlutKodi('litur', liturShop(s)) || (kodar('litur')[0] || 'gull'); }
  function val(s, o) {
    var k = { litur: liturShop(s), staerd: ST.staerd, lt: ST.lt, festing: ST.festing }, x;
    for (x in o) if (has(o, x)) k[x] = o[x];
    return k;
  }
  function munur(s, a, b) { var va = finna(val(s, a)), vb = finna(val(s, b)); return va && vb ? vb.verd - va.verd : 0; }

  /* ---------- engine data ---------- */
  function T(k) { return SNID[k || ST.snid] || LISTI[0] || null; }
  function rammiIBodi(Tm) { return !!(Tm && Tm.reglur && Tm.reglur.rammi === 'val'); }
  function syni() { return S().syni || {}; }
  /* what the engine draws; syni: the sample text while the name is empty (the badge is never blank) */
  function gogn(s, syn, o) {
    o = o || {};
    var n = trim(ST.nafn), ti = ST.anTitils ? '' : trim(ST.titill);
    var D = { nafn: n, titill: ti, litur: o.litur || liturAf(s), staerd: o.staerd || ST.staerd, rammi: (o.rammi != null ? o.rammi : s.rammi) === 'med', takn: null, logo: null };
    if (syn && !n) { D.nafn = syni().nafn || ''; if (!ti && !ST.anTitils) D.titill = syni().titill || ''; }
    var lt = o.lt || ST.lt;
    if (lt === 'takn') D.takn = o.takn !== undefined ? o.takn : ST.takn;
    if (lt === 'logo') D.logo = ST.logo || 'stadgengill';
    return D;
  }
  function teiknaSvg(Tm, D, O) { var E = B(); if (!E || !Tm) return ''; if (!rammiIBodi(Tm)) D.rammi = false; return E.teikna(Tm, D, O); }
  function stadaNu(s) { var E = B(), Tm = T(); return E && Tm ? E.stada(Tm, gogn(s, false)) : { ok: false, vandamal: [] }; }

  /* ---------- Snid tiles: the customer's name in the look's own font under the badge (fix round 1) ----------
     A badge is about 3:1, so in a 4:3 tile on a phone its name was only 5 to 9 px high. The empty space under
     the badge now carries the name line again in that look's font, weight, style and case, as large as fits. */
  function svgLinur(svg) {
    var re = /<text\b([^>]*)>([\s\S]*?)<\/text>/g, m, am, ut = [];
    while ((m = re.exec(svg))) {
      var a = {}, re2 = /([\w-]+)="([^"]*)"/g;
      while ((am = re2.exec(m[1]))) a[am[1]] = am[2].replace(/&#39;/g, "'").replace(/&quot;/g, '"').replace(/&amp;/g, '&');
      ut.push({ a: a, t: m[2].replace(/<[^>]+>/g, '').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, '"').replace(/&#39;/g, "'").replace(/&amp;/g, '&') });
    }
    return ut;
  }
  var MAEL = null;
  /* width of txt at font size 1 in the line's font (canvas; a rough estimate without canvas) */
  function breidd1(a, txt, fs) {
    var ls = (parseFloat(a['letter-spacing']) || 0) / (fs || 1), w = 0;
    try {
      MAEL = MAEL || document.createElement('canvas').getContext('2d');
      MAEL.font = (a['font-style'] || 'normal') + ' ' + (a['font-weight'] || '400') + ' 100px ' + (a['font-family'] || 'sans-serif');
      w = MAEL.measureText(txt).width / 100;
    } catch (e) { w = 0; }
    if (!w) w = txt.length * 0.6;
    return w + Math.max(0, txt.length - 1) * ls;
  }
  function nafnFlis(svg) {
    var m = /viewBox="([^"]+)"/.exec(svg), V0 = m ? m[1].split(/[\s,]+/).map(Number) : null, L = svgLinur(svg), n = null, i;
    if (!V0 || V0.length !== 4 || !(V0[2] > 0) || !L.length) return svg;
    for (i = 0; i < L.length; i++) if (trim(L[i].t) && (!n || (parseFloat(L[i].a['font-size']) || 0) > (parseFloat(n.a['font-size']) || 0))) n = L[i];
    if (!n) return svg;
    var H = V0[2] * 0.75, nedan = H - V0[3];
    if (nedan < V0[2] * 0.2) return svg;
    /* a long name the engine broke over two lines: every line in the name's size and font is part of it */
    var fs = parseFloat(n.a['font-size']) || 4, hlutar = [];
    for (i = 0; i < L.length; i++) if (trim(L[i].t) && (parseFloat(L[i].a['font-size']) || 0) === fs && L[i].a['font-family'] === n.a['font-family'] && L[i].a['font-weight'] === n.a['font-weight']) hlutar.push(trim(L[i].t));
    var txt = hlutar.join(' ').replace(/\s+/g, ' '), rum = V0[2] * 0.94, cx = V0[0] + V0[2] / 2;
    var linur = [txt], st = Math.min(nedan * 0.5, rum / breidd1(n.a, txt, fs));
    if (st < V0[2] * 0.105 && txt.indexOf(' ') > 0) {
      /* too long for one readable line: two lines, split at the space nearest the middle */
      var best = -1, j;
      for (j = 0; j < txt.length; j++) if (txt.charAt(j) === ' ' && (best < 0 || Math.abs(j - txt.length / 2) < Math.abs(best - txt.length / 2))) best = j;
      var l2 = [txt.slice(0, best), txt.slice(best + 1)], s2 = Math.min(nedan / 2.5, rum / Math.max(breidd1(n.a, l2[0], fs), breidd1(n.a, l2[1], fs)));
      if (s2 > st) { linur = l2; st = s2; }
    }
    st = Math.min(st, V0[2] * 0.12);
    var ls = (parseFloat(n.a['letter-spacing']) || 0) * st / fs, midja = V0[1] + V0[3] + nedan / 2;
    var att = ' text-anchor="middle" font-family="' + esc(n.a['font-family'] || 'sans-serif') + '" font-size="' + r3(st) + '" font-weight="' + esc(n.a['font-weight'] || '400') + '"' +
      (n.a['font-style'] ? ' font-style="' + esc(n.a['font-style']) + '"' : '') + (ls ? ' letter-spacing="' + r3(ls) + '"' : '') + ' fill="currentColor" text-rendering="geometricPrecision"';
    var y0 = linur.length === 1 ? midja + st * 0.35 : midja - st * 0.25, x = '';
    for (i = 0; i < linur.length; i++) x += '<text x="' + r3(cx) + '" y="' + r3(y0 + i * st * 1.2) + '"' + att + '>' + esc(linur[i]) + '</text>';
    return svg.replace(/viewBox="[^"]*"/, 'viewBox="' + V0[0] + ' ' + V0[1] + ' ' + V0[2] + ' ' + r3(H) + '"').replace(/<\/svg>\s*$/, x + '</svg>');
  }

  /* ---------- names ---------- */
  function heitiSnid(k) { var Tm = SNID[k]; return (Tm && tx(Tm.heiti)) || (ORD().snidHeiti || {})[k] || k; }
  function heitiLitur(k) { var E = B(); return (E && E.ord && E.ord.litir && E.ord.litir[k]) || k; }
  function heitiStaerd(k) { return ORD()['staerd_' + k] || heitiStaerdSkra(k); }
  function heitiStaerdSkra(k) { return (ORD().staerdHeiti || {})[k] || k; }
  function malStaerdar(k) { var i = stadur('staerd'), o = valkostir()[i], j = kodar('staerd').indexOf(k); return o && o.gildi[j] ? mal(o.gildi[j].nafn) : k; }
  function heitiFesting(f) { return (ORD().festing || {})[f] || f; }
  function heitiTakn(k) { var E = B(); return (E && E.TAKN_HEITI && E.TAKN_HEITI[k]) || k; }

  /* ---------- the wall: the owner's shirt photo at true scale (as sm-barmmerki.js 05c38680) ---------- */
  var SKYRTA = { mm: 259, b: 1564, h: 1060, x: 441, y: 587 };
  function skyrta(ctx) {
    var c = ctx.rammi, s = ctx.teikning && ctx.teikning.querySelector('svg');
    if (!c || !s || !V().skyrta || !s.viewBox || !s.viewBox.baseVal || !s.viewBox.baseVal.width) return;
    if (c.getAttribute('data-vs-barmmerki-skyrta') !== V().skyrta) {
      c.setAttribute('data-vs-barmmerki-skyrta', V().skyrta);
      c.style.setProperty('--vs-veggur', 'url(' + V().skyrta + ')');
      c.style.backgroundImage = 'url(' + V().skyrta + ')';
    }
    var r = s.getBoundingClientRect(), cb = c.getBoundingClientRect();
    if (!r.width || !cb.width || !cb.height) return;
    var vb = s.viewBox.baseVal, br = Math.min(r.width / vb.width, r.height / vb.height);
    var k = br * SKYRTA.mm / SKYRTA.b;
    k = Math.max(k, cb.width / SKYRTA.b, cb.height / SKYRTA.h);
    var bw = SKYRTA.b * k, bh = SKYRTA.h * k;
    var x = Math.min(0, Math.max(cb.width - bw, cb.width * 0.02 - SKYRTA.x * k));
    var y = Math.min(0, Math.max(cb.height - bh, cb.height * 0.5 - SKYRTA.y * k));
    /* no-repeat: if the frame ever outgrows the photo the shirt must not tile (a second collar showed at the foot) */
    c.style.backgroundRepeat = 'no-repeat';
    c.style.backgroundSize = Math.round(bw) + 'px ' + Math.round(bh) + 'px';
    c.style.backgroundPosition = Math.round(x) + 'px ' + Math.round(y) + 'px';
  }

  /* ---------- text fields (name, line under the name): built once, never rebuilt while typing ---------- */
  var athTimi = {};
  function athugasemd(el, k, texti) {
    var p = el.querySelector('[data-bm-ath="' + k + '"]');
    if (!p) return;
    p.textContent = texti; clearTimeout(athTimi[k]);
    if (texti) athTimi[k] = setTimeout(function () { p.textContent = ''; }, 8000);
  }
  /* kit units (K-reitur, K-bod, K-tillogur, lota 5 08.10): medAth puts the transient line (emoji / cut text) inside the field,
     tillHtml renders the 'try this' suggestions; the adapter keeps listening to its own data-XX-til buttons */
  function medAth(h, ath) { return h.replace(/<\/div>$/, function () { return ath + '</div>'; }); }
  function tillHtml(ctx, till, gagn) {
    var h = ctx.html.tillogur({ texti: t('reyndu'), kostir: till.map(function (x) { var g = {}; g[gagn] = x.k; return { gildi: x.k, heiti: x.texti, gogn: g }; }) });
    return h.replace(/<\/div>$/, function () { return '<span>' + esc(t('styttra')) + '</span></div>'; });
  }
  function smidaTexta(el, ctx) {
    if (el.__bmTexti) return;
    el.__bmTexti = true;
    var id = 'vs-' + ctx.id + '-bm';
    var reitur = function (k, merki, syn, aukalina) {
      return medAth(ctx.html.reitur({ id: id + '-' + k, heiti: merki, valfrjalst: k === 'titill', hamark: 60, teljari: false, villa: false, synishorn: syn,
        hjalp: k === 'titill' ? t('titill_hjalp') : '', lysing: id + '-a-' + k, skylda: k === 'nafn', fokus: k,
        attr: { autocomplete: 'off', spellcheck: 'false', autocapitalize: k === 'nafn' ? 'words' : null },
        gogn: { 'bm-texti': k }, reitGogn: { 'bm-reitur': k } }),
        ctx.html.bod('', 'hjalp', { id: id + '-a-' + k, gogn: { 'bm-ath': k } }) + (aukalina || ''));
    };
    ctx.html.setja(el, ctx.html.reitir([
      reitur('nafn', t('nafn'), syni().nafn || ''),
      reitur('titill', t('titill'), syni().titill || '',
        ctx.html.rofi({ heiti: t('an_titils'), fokus: 'an-titils', gogn: { 'bm-an-titils': true } }))
    ]) + '<div data-bm-tillogur aria-live="polite"></div>');
    ['nafn', 'titill'].forEach(function (k) {
      var inp = el.querySelector('[data-bm-texti="' + k + '"]');
      function hreinsa() {
        var v = inp.value || '', n = v.replace(TAKN_RE, '');
        if (n === v) return false;
        var pos = typeof inp.selectionStart === 'number' ? inp.selectionStart : v.length, ny = v.slice(0, pos).replace(TAKN_RE, '').length;
        inp.value = n;
        try { if (document.activeElement === inp) inp.setSelectionRange(ny, ny); } catch (e) {}
        return true;
      }
      function uppfaera(e) {
        if (e && e.isComposing) return;
        if (hreinsa()) athugasemd(el, k, t('emoji'));
        ST[k] = inp.value || '';
        if (k === 'nafn' && ST.nafn) ST.snert = true;
        ctx.breytt();
      }
      inp.addEventListener('paste', function (e) {
        var cd = e.clipboardData || window.clipboardData, txt = cd && cd.getData ? cd.getData('text') : null;
        if (txt == null) return;
        txt = String(txt).replace(/\r\n|\r|\n|\t/g, ' ').replace(TAKN_RE, '');
        var v = inp.value || '', s0 = inp.selectionStart || 0, s1 = inp.selectionEnd || 0, max = inp.maxLength;
        var pl = max > 0 ? Math.max(0, max - (v.length - (s1 - s0))) : txt.length;
        if (txt.length > pl) {
          e.preventDefault();
          inp.value = v.slice(0, s0) + txt.slice(0, pl) + v.slice(s1);
          try { inp.setSelectionRange(s0 + pl, s0 + pl); } catch (x) {}
          athugasemd(el, k, t('klippt', { n: max }));
          uppfaera();
        }
      });
      inp.addEventListener('input', uppfaera);
      inp.addEventListener('compositionend', function () { uppfaera(); });
      if (k === 'nafn') inp.addEventListener('blur', function () { ST.snert = true; ctx.uppfaera(); });
      hreinsa();
      ST[k] = inp.value || '';
    });
    var cb = el.querySelector('[data-bm-an-titils]'), ti = el.querySelector('[data-bm-texti="titill"]');
    cb.addEventListener('change', function () {
      ST.anTitils = cb.checked; ti.disabled = cb.checked; ti.style.opacity = cb.checked ? '.55' : '';
      ctx.breytt();
    });
    el.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('[data-bm-til]') : null;
      if (!b) return;
      var a = b.getAttribute('data-bm-til').split(':');
      if (a[0] === 'staerd') ST.staerd = a[1]; else ST.snid = a[1];
      ctx.breytt();
      ctx.tilkynna(a[0] === 'staerd' ? heitiStaerd(a[1]) : heitiSnid(a[1]), false);
    });
  }
  /* sizes, then looks, that fit the text when it does not fit (as the old page) */
  function tillogur(s) {
    var E = B(), D = gogn(s, false), ut = [];
    if (!E || !D.nafn || !T()) return ut;
    kodar('staerd').forEach(function (k) {
      if (k === ST.staerd || !finna(val(s, { staerd: k }))) return;
      var Dk = gogn(s, false, { staerd: k });
      if (E.stada(T(), Dk).ok) ut.push({ k: 'staerd:' + k, texti: t('skipta_staerd', { s: heitiStaerd(k) + ', ' + malStaerdar(k) }) });
    });
    LISTI.forEach(function (Tm) {
      if (Tm.key === ST.snid || ut.length >= 3) return;
      if (E.stada(Tm, D).ok) ut.push({ k: 'snid:' + Tm.key, texti: t('skipta_snid', { s: heitiSnid(Tm.key) }) });
    });
    return ut.slice(0, 3);
  }
  function stoppar(s) { return (stadaNu(s).vandamal || []).filter(function (v) { return v.stopp && v.kodi !== 'vantar_nafn'; }); }

  /* ---------- tiles: one helper for every change listener of a body ---------- */
  function tengja(el, fall) {
    el.__bmFall = fall;
    if (el.__bmTengt) return;
    el.__bmTengt = true;
    el.addEventListener('change', function (e) { var x = e.target; if (x && x.type === 'radio' && el.__bmFall) el.__bmFall(x); });
  }
  var TAKN_SVG = {};
  function taknSvg(k) {
    if (TAKN_SVG[k]) return TAKN_SVG[k];
    var E = B(), d = ((E && E.TAKN && E.TAKN[k]) || []).map(function (p) { return '<path d="' + esc(p) + '"/>'; }).join('');
    return (TAKN_SVG[k] = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">' + d + '</svg>');
  }

  /* ---------- production file (SMFram), 08.10: the same layout the preview draws (E.uppsetning) as an SMFram spec ----------
     Text = GRAFA outlines (font ids from the template, as the preview's CSS fonts), template dividers + the frame =
     LINA score lines (the frame on the centre line the preview draws), icon / ring = GRAFA outlines of the strokes the
     preview strokes, logo = GRAFA-MYND mask (or the dashed LOGO box), plate outline = SKERA-YTRA. The record f
     (SMV1) stays the _framleidsla JSON next to it (the kit posts spec.json as _framleidsla). */
  var SVGNS = 'http://www.w3.org/2000/svg', MAELIR = null;
  function maelir() {
    if (MAELIR && MAELIR.parentNode) return MAELIR;
    var sv = document.createElementNS(SVGNS, 'svg');
    sv.setAttribute('width', '0'); sv.setAttribute('height', '0'); sv.setAttribute('aria-hidden', 'true');
    sv.style.cssText = 'position:absolute;width:0;height:0;overflow:hidden;visibility:hidden;pointer-events:none';
    (document.body || document.documentElement).appendChild(sv);
    return (MAELIR = sv);
  }
  /* the icon paths (24 unit box) sampled to polylines, every skref units: [{ pts: [[x, y], ...], closed }]
     (one sub path at a time, as takn-tabler bua.mjs does it, so relative moves keep their start) */
  function sniddu(dlist, skref) {
    var sv = maelir(), ut = [];
    dlist.forEach(function (d) {
      var seg = String(d).match(/[Mm][^Mm]*/g) || [], i;
      for (i = 0; i < seg.length; i++) {
        var pre = seg.slice(0, i).join(''), p = document.createElementNS(SVGNS, 'path'), p0 = document.createElementNS(SVGNS, 'path');
        p.setAttribute('d', pre + seg[i]); p0.setAttribute('d', pre || 'M0 0'); sv.appendChild(p); sv.appendChild(p0);
        var L0 = pre ? p0.getTotalLength() : 0, L1 = p.getTotalLength(), pts = [], t, q;
        for (t = L0 + 1e-4; t < L1; t += skref) { q = p.getPointAtLength(t); pts.push([q.x, q.y]); }
        q = p.getPointAtLength(L1); pts.push([q.x, q.y]);
        var a = pts[0], b = pts[pts.length - 1], lokud = /[zZ]\s*$/.test(seg[i]) || (pts.length > 3 && Math.abs(a[0] - b[0]) + Math.abs(a[1] - b[1]) < 0.02);
        if (lokud && Math.abs(a[0] - b[0]) + Math.abs(a[1] - b[1]) < 0.02) pts.pop();
        ut.push({ pts: pts, closed: lokud });
        sv.removeChild(p); sv.removeChild(p0);
      }
    });
    return ut;
  }
  /* a polygon with the one orientation every piece of an outline must have (SMFram unions GRAFA as nonzero, so
     mixed orientations would cancel where pieces overlap) */
  function stefna(P) {
    var a = 0, i, n = P.length;
    for (i = 0; i < n; i++) a += P[i][0] * P[(i + 1) % n][1] - P[(i + 1) % n][0] * P[i][1];
    return a > 0 ? P.slice().reverse() : P;
  }
  function polyD(P) { return 'M' + P.map(function (q) { return r3(q[0]) + ' ' + r3(q[1]); }).join('L') + 'Z'; }
  /* the outline of a stroke of width sw with round caps and joins (mm): one quad per segment and one disc per
     point, all one orientation; SMFram unions them, so the file holds exactly the inked area of the stroke */
  function strikSlod(subs, sw) {
    var r = sw / 2, d = '', N = 14;
    function skifa(c) { var P = [], j, a; for (j = 0; j < N; j++) { a = 2 * Math.PI * j / N; P.push([c[0] + r * Math.cos(a), c[1] + r * Math.sin(a)]); } return P; }
    subs.forEach(function (sb) {
      var Q = sb.pts, n = Q.length, j, m = sb.closed ? n : n - 1;
      for (j = 0; j < m; j++) {
        var a = Q[j], b = Q[(j + 1) % n], dx = b[0] - a[0], dy = b[1] - a[1], L = Math.sqrt(dx * dx + dy * dy);
        if (L < 1e-6) continue;
        var nx = -dy / L * r, ny = dx / L * r;
        d += polyD(stefna([[a[0] + nx, a[1] + ny], [b[0] + nx, b[1] + ny], [b[0] - nx, b[1] - ny], [a[0] - nx, a[1] - ny]]));
      }
      Q.forEach(function (c) { d += polyD(stefna(skifa(c))); });
    });
    return d;
  }
  /* an icon box (mm) -> the outline of its stroke, as the preview strokes it (width tk.strik or 0.3 to 0.5 mm) */
  function taknSlod(tk, E) {
    var paths = (E.TAKN && E.TAKN[tk.key]) || [], k = tk.s / 24, sw = tk.strik || Math.max(0.3, Math.min(0.5, tk.s * 0.07));
    if (!paths.length) return '';
    var subs = sniddu(paths, 0.22 / k);
    subs.forEach(function (sb) { sb.pts = sb.pts.map(function (q) { return [tk.x + q[0] * k, tk.y + q[1] * k]; }); });
    return strikSlod(subs, sw);
  }
  /* an engraved ring (flatar form hringur with strik): the circle on the centre line of the stroke */
  function hringSlod(fl) {
    var cx = fl.x + fl.w / 2, cy = fl.y + fl.h / 2, r = Math.min(fl.w, fl.h) / 2 - fl.strik / 2, n = 96, pts = [], j;
    for (j = 0; j < n; j++) pts.push([cx + r * Math.cos(2 * Math.PI * j / n), cy + r * Math.sin(2 * Math.PI * j / n)]);
    return strikSlod([{ pts: pts, closed: true }], fl.strik);
  }
  /* the dashed LOGO box the workshop puts the customer's file into (as sm-barm-vel.js reiturMynd) */
  function reiturMynd(w, h) {
    try {
      var k = 20, c = document.createElement('canvas'), cw = Math.max(4, Math.round(w * k)), ch = Math.max(4, Math.round(h * k)), lw = 0.3 * k, x;
      c.width = cw; c.height = ch; x = c.getContext('2d');
      x.strokeStyle = '#000000'; x.lineWidth = lw;
      if (x.setLineDash) x.setLineDash([1.2 * k, 0.8 * k]);
      x.strokeRect(lw / 2, lw / 2, cw - lw, ch - lw);
      return c.toDataURL('image/png');
    } catch (e) { return null; }
  }
  function mmT(n) { return String(r3(n)).replace('.', ','); }
  function logoLysing() {
    var el = CTX && CTX.rot && CTX.rot.querySelector('[data-sm-skra-texti]');
    return el ? trim(el.value) : '';
  }
  /* the whole spec for the production file, or null when the engine or the look is not there */
  function framSpec(s) {
    var E = B(), Tm = T(); if (!E || !Tm || !E.uppsetning) return null;
    var D = gogn(s, false);
    if (!rammiIBodi(Tm)) D.rammi = false;
    var U = E.uppsetning(Tm, D, {}), Fo = (E.ord && E.ord.framV) || {}, hl = [], B0 = U.B, H0 = U.H;
    U.textar.forEach(function (t0) {
      t0.linur.forEach(function (ln) {
        var el = { gerd: 'texti', lag: 'GRAFA', texti: ln.t, letur: E.smfLetur(t0.L), mm: r3(t0.s), x: r3(ln.x), y: r3(ln.y), jofnun: 'vinstri' };
        if (t0.L.tracking_em) el.stafabil = t0.L.tracking_em;
        if (t0.sx < 0.999) { el.kreista = r3(t0.sx); el.kreistaUm = r3(ln.x); }
        hl.push(el);
      });
    });
    (U.flatar || []).forEach(function (fl) {
      if (fl.form === 'hringur' && fl.strik) hl.push({ gerd: 'slod', lag: 'GRAFA', d: hringSlod(fl) });
      else if (fl.form === 'hringur') hl.push({ gerd: 'hringur', lag: 'GRAFA', cx: r3(fl.x + fl.w / 2), cy: r3(fl.y + fl.h / 2), r: r3(Math.min(fl.w, fl.h) / 2) });
      else if (fl.d) hl.push({ gerd: 'slod', lag: 'GRAFA', d: fl.d });
      else hl.push({ gerd: 'rett', lag: 'GRAFA', x: r3(fl.x), y: r3(fl.y), w: r3(fl.w), h: r3(fl.h), r: r3(fl.horn || 0) });
    });
    /* the frame: one score line on the centre line the preview draws (inset + half the line), like the other lines */
    if (U.rammi) [].concat(U.rammi).forEach(function (rm) {
      var i = rm.inset != null ? rm.inset : 1.5, sw = rm.strik || 0.3, rr = rm.horn != null ? rm.horn : Math.max(0.3, U.horn - i);
      hl.push({ gerd: 'rett', lag: 'LINA', x: r3(i + sw / 2), y: r3(i + sw / 2), w: r3(B0 - 2 * i - sw), h: r3(H0 - 2 * i - sw), r: r3(rr) });
    });
    /* the template's own dividers: score lines, like the frame */
    (U.linur || []).forEach(function (ln) {
      hl.push({ gerd: 'slod', lag: 'LINA', d: 'M' + r3(ln.x1) + ' ' + r3(ln.y1) + 'L' + r3(ln.x2) + ' ' + r3(ln.y2) });
    });
    if (U.takn) { var td = taknSlod(U.takn, E); if (td) hl.push({ gerd: 'slod', lag: 'GRAFA', d: td }); }
    var g = U.logo, nf = '', lt = '';
    if (g) {
      if (ST.logoSkra) nf = ST.logoSkra.name || '';
      else lt = logoLysing();
      if (!g.stadgengill && g.mynd) hl.push({ gerd: 'mynd', lag: 'GRAFA-MYND', src: g.mynd, x: r3(g.x), y: r3(g.y), w: r3(g.w), h: r3(g.h), nafn: 'logo', maski: true });
      else { var rmy = reiturMynd(g.w, g.h); if (rmy) hl.push({ gerd: 'mynd', lag: 'GRAFA-MYND', src: rmy, x: r3(g.x), y: r3(g.y), w: r3(g.w), h: r3(g.h), nafn: 'logo-reitur' }); }
    }
    hl.push({ gerd: 'rett', lag: 'SKERA-YTRA', x: 0, y: 0, w: B0, h: H0, r: U.horn });
    var lys = [[Fo.efni || 'Efni', heitiLitur(liturAf(s))], [Fo.staerd || 'Staerd', heitiStaerdSkra(U.staerd) + ', ' + mmT(B0) + ' \u00d7 ' + mmT(H0) + ' mm'], [Fo.plata || 'Plata', Fo.akryl || '']];
    var ei = A.eiginleikar(s, CTX) || [];
    ei.forEach(function (x) { if (x && x[0] && x[1] != null && String(x[1]) !== '') lys.push([x[0], String(x[1])]); });
    if (g) {
      if (!g.stadgengill) lys.push([Fo.logo || 'Logo', (Fo.logoMynd || '') + (nf ? ' (' + nf + ')' : '')]);
      else if (nf) lys.push([Fo.logo || 'Logo', nf + '. ' + (Fo.logoSkra || '')]);
      else if (lt) lys.push([Fo.logo || 'Logo', String(Fo.logoLysing || '').replace('{t}', lt)]);
      else lys.push([Fo.logo || 'Logo', Fo.logoSidar || '']);
      lys.push([Fo.reitur || 'Logo-reitur', 'x ' + mmT(g.x) + ', y ' + mmT(g.y) + ', ' + mmT(g.w) + ' \u00d7 ' + mmT(g.h) + ' mm']);
    }
    var ord = trim(D.nafn).split(/\s+/).slice(0, 2).join(' ');
    return { vara: 'barmmerki', efni: E.litLykill(D.litur), staerd: U.staerd, snid: 'barmmerki.' + (Tm.key || '') + '@' + (Tm.v || 1), ord: ord, w: B0, h: H0, lysing: lys, hlutir: hl };
  }

  /* 15.10: takka-hamur (section setting "takkar" -> data-takkar): Snid, Litur and Rammi become pills under the preview (ctx.takkar of the kit).
     They do what the steps do (Snid: the same state change as the tiles; Litur and Rammi: a click on the kit's radios), so the variant,
     price, cart properties and the production file are the same; the three steps are hidden (data-takka-fel) but stay in the DOM.
     Without data-takkar none of this runs. */
  var takkaBar = null;
  function erTakkar(ctx) { return !!(ctx && ctx.rot && ctx.rot.hasAttribute && ctx.rot.hasAttribute('data-takkar')); }
  function takkaRadio(ctx, l, f) {
    var s = ctx.skref(l), r = s && s.el ? s.el.querySelectorAll('input[type=radio]') : [];
    for (var i = 0; i < r.length; i++) if (f(r[i])) return r[i];
    return null;
  }
  function asciiNafn(x) {
    var m = { '\u00e1': 'a', '\u00f0': 'd', '\u00e9': 'e', '\u00ed': 'i', '\u00f3': 'o', '\u00fa': 'u', '\u00fd': 'y', '\u00fe': 'th', '\u00e6': 'ae', '\u00f6': 'o' };
    return String(x || '').toLowerCase().replace(/[\u00e1\u00f0\u00e9\u00ed\u00f3\u00fa\u00fd\u00fe\u00e6\u00f6]/g, function (c) { return m[c]; }).replace(/[^a-z0-9]+/g, '-');
  }
  var TAKKA_PUNKTAR = { 'gull': 'gull', 'silfur': 'silfur', 'svart': 'svart', 'hvitt': 'hvitt' };
  function takkaSmida(ctx) {
    var lit = [], snid = [], i;
    var radios = ctx.skref('litur') && ctx.skref('litur').el ? ctx.skref('litur').el.querySelectorAll('input[type=radio]') : [];
    if (!radios.length || !LISTI.length) return null;
    var allirPunktar = true;
    for (i = 0; i < radios.length; i++) if (!TAKKA_PUNKTAR[asciiNafn(radios[i].getAttribute('data-nafn'))]) allirPunktar = false;
    Array.prototype.forEach.call(radios, function (r0) {
      var kodi = r0.value, nafn = r0.getAttribute('data-nafn') || kodi, a = asciiNafn(nafn);
      var p = { k: 'litur-' + a, t: nafn, til: function () { return true; },
        kv: function () { var r = takkaRadio(ctx, 'litur', function (x) { return x.value === kodi; }); return !!r && r.checked; },
        smella: function (kv) { if (kv) return; var r = takkaRadio(ctx, 'litur', function (x) { return x.value === kodi; }); if (r) r.click(); } };
      if (allirPunktar) p.punktur = TAKKA_PUNKTAR[a];
      lit.push(p);
    });
    LISTI.forEach(function (Tm) {
      snid.push({ k: 'snid-' + Tm.key, t: heitiSnid(Tm.key), til: function () { return true; }, kv: function () { return ST.snid === Tm.key; },
        smella: function (kv) { if (!kv) { ST.snid = Tm.key; ctx.breytt(); } } });
    });
    return ctx.takkar({
      fela: ['snid', 'litur', 'rammi'],
      hopar: [
        { heiti: ORD().takki_snid || 'Sni\u00f0', pillur: snid },
        { heiti: ORD().takki_litur || 'Litur', punktar: allirPunktar, pillur: lit },
        { heiti: ORD().takki_rammi || 'Rammi', pillur: [
          { k: 'rammi', t: ctx.t('rammi') || 'Rammi',
            til: function () { var s = ctx.skref('rammi'); return !!(s && s.synilegt); },
            kv: function () { var r = takkaRadio(ctx, 'rammi', function (x) { return x.checked; }); return !!r && r.value === 'med'; },
            smella: function (kv) { var r = takkaRadio(ctx, 'rammi', function (x) { return x.value === (kv ? 'an' : 'med'); }); if (r) r.click(); } }
        ] }
      ]
    });
  }

  var A = {
    gerd: 'svg', skuggi: false, lifandi: true,
    upphaf: function (ctx) {
      CTX = ctx;
      var s0 = S(), q = {};
      try { (window.location.search || '').replace(/^\?/, '').split('&').forEach(function (p) { var a = p.split('='); if (a[0]) q[decodeURIComponent(a[0])] = decodeURIComponent(a[1] || ''); }); } catch (e) {}
      var listi = s0.snid || [];
      ST.snid = listi.indexOf(q.snid) >= 0 ? q.snid : (s0.snidD || listi[0] || 'sigilt');
      /* size, logo and fastening from the variant the page opened on (?variant=) */
      /* ?variant= wins; else the template's default size (the kit opens on the first variant) */
      /* lysandi slod (K3): ctx.afbUrSlod is true for the old ?variant= link too, not only the new readable params */
      var a = ctx.afbUrSlod ? ctx.afbrigdi : null, st0 = { staerd: s0.staerdD || '76x25', lt: 'ekkert', festing: 'engin' };
      if (a && a.o) hlutverk().forEach(function (h, i) {
        var k = hlutKodi(h, a.o[i]);
        if (!k) return;
        if (h === 'staerd') st0.staerd = k;
        else if (h === 'vidbot') { st0.lt = k.split('-')[0] === 'ja' ? 'logo' : 'ekkert'; st0.festing = k.split('-')[1]; }
        else if (h === 'logo') st0.lt = k === 'ja' ? 'logo' : 'ekkert';
        else if (h === 'festing') st0.festing = k;
      });
      ST.staerd = st0.staerd; ST.lt = st0.lt; ST.festing = st0.festing;
      /* the logo file: the engine draws it as it would be engraved (sm-skra event, as the old page) */
      ctx.rot.addEventListener('sm:skra', function (e) {
        var d = e.detail || {}, skra = d.skra || null;
        if (d.eiginleiki && d.eiginleiki !== 'Logo') return;
        ST.logoSkra = skra; ST.logo = null; ST.logoNr += 1;
        if (!skra) { ST.logoSkb = ''; ctx.breytt(); return; }
        ST.logoSkb = t('logo_hled', { f: skra.name || '' });
        ctx.breytt();
        var E = B(); if (!E) return;
        E.grafaLogo(skra, function (r) {
          if (ST.logoSkra !== skra) return;
          if (r && r !== 'stadgengill') { ST.logo = r; ST.logoSkb = t('logo_komid', { f: skra.name || '' }); }
          else { ST.logo = 'stadgengill'; ST.logoSkb = t(r === 'stadgengill' ? 'logo_stadgengill' : 'logo_olesanlegt', { f: skra.name || '' }); }
          ST.logoNr += 1;
          ctx.breytt();
        });
      });
      ctx.rot.addEventListener('input', function (e) { if (e.target && e.target.matches && e.target.matches('[data-sm-skra-texti]')) ctx.breytt(); });
      window.addEventListener('resize', function () { if (CTX) skyrta(CTX); });
      /* the pinned preview grows when the site header scrolls away (no resize event): refit the shirt to the frame */
      if (ctx.rammi && 'ResizeObserver' in window) new ResizeObserver(function () { if (CTX) skyrta(CTX); }).observe(ctx.rammi);
    },
    hlada: function (ctx) {
      CTX = ctx;
      if (HLADID) return HLADID;
      var E = B(), slod = V().snidmat;
      if (!E || !slod) return (HLADID = Promise.resolve(null));
      E.efni = V().efni || E.efni;
      HLADID = fetch(slod, { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(String(r.status)); return r.json(); })
        .then(function (j) {
          var listi = j.snid || j;
          (listi || []).forEach(function (Tm) { if (Tm && Tm.key) SNID[Tm.key] = Tm; });
          LISTI = (S().snid || []).map(function (k) { return SNID[k]; }).filter(Boolean);
          if (!LISTI.length) LISTI = listi || [];
          if (!SNID[ST.snid] && LISTI[0]) ST.snid = LISTI[0].key;
          TILBUID = true;
          ctx.breytt();
          return E.hlada(LISTI, { efni: E.efni });
        })
        .then(function () { ctx.flisar(); ctx.breytt(); })
        ['catch'](function (e) { if (window.console) console.warn('sm-vs-barmmerki: snidmatin hlodust ekki', e && e.message); });
      return HLADID;
    },
    teikna: function (ctx, s) {
      CTX = ctx;
      if (!TILBUID) return;
      var svg = teiknaSvg(T(), gogn(s, true), { skuggi: true, aria: '' });
      if (ctx.teikning.__bmSvg !== svg) { ctx.teikning.innerHTML = svg; ctx.teikning.__bmSvg = svg; }
      skyrta(ctx);
      if (erTakkar(ctx) && ctx.takkar) { if (!takkaBar) takkaBar = takkaSmida(ctx); if (takkaBar) takkaBar.uppfaera(); }
    },
    lysing: function (s) {
      var D = gogn(s, true), Tm = T();
      return t('aria', { snid: heitiSnid(ST.snid), litur: heitiLitur(liturAf(s)), staerd: malStaerdar(ST.staerd),
        texti: [D.nafn, D.titill].filter(Boolean).join(', ') + (s.rammi === 'med' && rammiIBodi(Tm) ? ', ' + t('rammi_med') : '') });
    },
    /* 14.10 (samraeming): "Daemi" flagan a myndinni (kitid teiknar hana) medan synishornid er teiknad en ekkert hefur verid skrifad */
    daemi: function (s, ctx) { return !trim(ST.nafn) ? ((ctx && ctx.vel && ctx.vel.ord && ctx.vel.ord.daemi_merki) || 'Dæmi, skrifaðu þitt nafn') : false; },
    malband: function () { var E = B(), m = E && E.STAERDIR && E.STAERDIR[ST.staerd]; return m ? { b: m.b / 10, h: m.h / 10, eining: 'cm' } : null; },
    smamynd: function (s) { return TILBUID ? { svg: teiknaSvg(T(), gogn(s, false), { skuggi: false, spassia: 1, aria: '' }) } : null; },
    afbrigdi: function (s) {
      if (!kodarOk()) return null;
      var a = finna(val(s, {}));
      return a ? { id: a.id } : null;
    },
    hjalp: function () { var Tm = T(); return { snid: Tm ? tx(Tm.lysing) : '' }; },
    slod: function () { return { snid: ST.snid || null }; },
    rammi: function () {
      var Tm = T(), E = B(), g = Tm && Tm.staerdir && Tm.staerdir[ST.staerd] && Tm.staerdir[ST.staerd].rammi;
      if (!Tm) return { gerd: 'lina', inset: 1.4, insetY: 1.4, r: 1.6, form: 'rett', verd: 'okeypis' };
      if (!rammiIBodi(Tm) || !g) return { gerd: null };
      var i = g.inset != null ? g.inset : 1.5, sw = g.strik || 0.3;
      return { gerd: 'lina', inset: i + sw / 2, insetY: i + sw / 2, r: Math.max(0.3, ((E && E.HORN) || 3) - i), form: 'rett', verd: 'okeypis' };
    },
    syna: function (lykill) {
      if (lykill === 'logo') return ST.lt === 'logo';
      return undefined;
    },
    athuga: function (s) {
      var ut = [];
      if (!trim(ST.nafn)) ut.push({ kodi: 'vantar_nafn', reitur: 'texti', stopp: true, texti: t('skrifa_nafn'), hnappur: t('vantar_nafn'), strax: ST.snert });
      if (TILBUID) (stadaNu(s).vandamal || []).forEach(function (v) {
        if (v.kodi === 'vantar_nafn' || /^(logo_ekki_i_bodi|logo_passar_ekki|takn_passar_ekki|takn_othekkt|staerd_vantar)$/.test(v.kodi)) return;
        var hn = v.kodi === 'nafn_of_langt' ? t('nafn_langt') : v.kodi === 'titill_of_langur' ? t('titill_langur') : v.kodi === 'of_hatt' ? t('of_hatt_hn') : '';
        ut.push({ kodi: v.kodi, reitur: 'texti', stopp: !!v.stopp, texti: t(v.kodi) || v.texti, hnappur: hn, strax: true });
      });
      if (ST.lt === 'takn' && !ST.takn) ut.push({ kodi: 'takn', reitur: 'lt', stopp: true, texti: t('takn_vantar'), hnappur: t('veldu_takn') });
      return ut;
    },
    eiginleikar: function (s, ctx) {
      var E = ORD().eig || {}, EG = ORD().eigGildi || {}, D = gogn(s, false), ut = [];
      ut.push([E.snid, (EG.snid || {})[ST.snid] || heitiSnid(ST.snid)]);
      ut.push([E.nafn, D.nafn]);
      if (D.titill) ut.push([E.titill, D.titill]);
      if (ST.lt === 'takn' && ST.takn) ut.push([E.takn, (EG.takn || {})[ST.takn] || heitiTakn(ST.takn)]);
      if (s.rammi) { var rs = ctx.skref('rammi'), r = rs && rs.el.querySelector('input:checked'); if (r) ut.push([ctx.eiginleiki('rammi') || E.rammi, r.getAttribute('data-nafn') || '']); }
      ut.push([E.festing, (EG.festing || {})[ST.festing] || heitiFesting(ST.festing)]);
      var aths = trim(s.aths);
      if (aths) ut.push([ctx.eiginleiki('aths') || E.aths, aths]);
      return ut;
    },
    framleidsla: function (s) {
      var E = B(), Tm = T(); if (!E || !Tm) return null;
      var D = gogn(s, false);
      if (!rammiIBodi(Tm)) D.rammi = false;
      var f = E.framleidsla(Tm, D, { logo: ST.lt === 'logo' ? (ST.logoSkra ? 'skra' : 'lysing') : null });
      f.festing = ST.festing;
      f.tungumal = (document.documentElement.getAttribute('lang') || 'is').slice(0, 5);
      /* 08.10: the production FILE too (SMFram), the record f stays the _framleidsla JSON beside it; when the spec
         cannot be made the record alone goes, as before */
      try {
        var sp = framSpec(s);
        if (!sp || !sp.hlutir.length || !sp.w || !sp.h || !window.SMFram || !window.SMFram.baetaVid) return { json: f };
        sp.json = f;
        return sp;
      } catch (e) { try { console.warn('[SMFram] barmmerki: ' + (e && e.message)); } catch (x) {} return { json: f }; }
    },
    framTimi: 12000,
    forhlada: function (s) { try { if (window.SMFram && window.SMFram.forhlada && TILBUID) { var sp = framSpec(s); if (sp) window.SMFram.forhlada(sp); } } catch (e) {} },
    vandamal: function (v, ctx) {
      var el = ctx.skref('texti'); el = el && el.el.querySelector('[data-vs-sersnid]');
      if (!el) return;
      var ni = el.querySelector('[data-bm-texti="nafn"]'), ti = el.querySelector('[data-bm-texti="titill"]');
      var synd = function (k) { return v.some(function (x) { return x.stopp && x.kodi && (k === 'nafn' ? /^(vantar_nafn|nafn_of_langt|of_hatt)$/.test(x.kodi) && (x.kodi !== 'vantar_nafn' || ctx.reynt() || ST.snert) : x.kodi === 'titill_of_langur'); }); };
      if (ni) ni.setAttribute('aria-invalid', synd('nafn') ? 'true' : 'false');
      if (ti) ti.setAttribute('aria-invalid', synd('titill') ? 'true' : 'false');
      var box = el.querySelector('[data-bm-tillogur]');
      if (box) {
        var stop = TILBUID && trim(ST.nafn) ? stoppar(stadaFyrir()) : [], h = '';
        if (stop.length) {
          var till = tillogur(stadaFyrir());
          if (till.length) h = tillHtml(ctx, till, 'bm-til');
        }
        ctx.html.setja(box, h);
      }
    },
    utlit: {
      teikna: function (s2, ctx, o) {
        if (!TILBUID) return null;
        var Tm = T(), D, O = { skuggi: false, spassia: 1.2, aria: '' };
        if (o.lykill === 'snid') Tm = SNID[o.gildi] || Tm;
        D = gogn(s2, true);
        if (o.lykill === 'staerd') {
          D.staerd = o.gildi;
          var svg = teiknaSvg(Tm, D, O), E = B(), m = E.STAERDIR[o.gildi], p = 1.2, W0 = 76 + 2 * p, H0 = 38 + 2 * p;
          if (!m) return { svg: svg };
          var vb = r3(-p - (W0 - m.b - 2 * p) / 2) + ' ' + r3(-p - (H0 - m.h - 2 * p) / 2) + ' ' + r3(W0) + ' ' + r3(H0);
          return { svg: svg.replace(/viewBox="[^"]*"/, 'viewBox="' + vb + '"') };
        }
        return { svg: o.lykill === 'snid' ? nafnFlis(teiknaSvg(Tm, D, O)) : teiknaSvg(Tm, D, O) };
      },
      lykill: function (s2, ctx, o) {
        var D = gogn(s2, true);
        return JSON.stringify([o.lykill, o.gildi, o.lykill === 'snid' ? o.gildi : ST.snid, D.litur, o.lykill === 'staerd' ? o.gildi : ST.staerd, D.nafn, D.titill, D.rammi, D.takn, ST.lt === 'logo' ? ST.logoNr : -1]);
      }
    },
    skref: {
      snid: {
        teikna: function (el, s, ctx) {
          if (!LISTI.length) return;
          var k = LISTI.map(function (Tm) { return { gildi: Tm.key, heiti: heitiSnid(Tm.key), valid: Tm.key === ST.snid }; });
          ctx.html.setja(el, ctx.html.kostir({ nafn: 'vs-' + ctx.id + '-snid', birting: 'utlit', lykill: 'snid', klasi: 'vs-barmmerki-snid', kostir: k }));
          Array.prototype.forEach.call(el.querySelectorAll('input'), function (i) { i.checked = i.value === ST.snid; });
          tengja(el, function (x) { ST.snid = x.value; ctx.breytt(); });
        },
        gildi: function () { return heitiSnid(ST.snid); },
        buid: function () { return !!ST.snid; }
      },
      staerd: {
        teikna: function (el, s, ctx) {
          var k = kodar('staerd').map(function (sk) {
            var a = finna(val(s, { staerd: sk }));
            return { gildi: sk, heiti: heitiStaerd(sk), undir: malStaerdar(sk) + (a ? ', ' + kr(a.verd) : ''), valid: sk === ST.staerd, ovirkt: !a || a.til === false, ekki: !a };
          });
          ctx.html.setja(el, ctx.html.kostir({ nafn: 'vs-' + ctx.id + '-staerd', birting: 'utlit', lykill: 'staerd', dalkar: 3, kostir: k }));
          Array.prototype.forEach.call(el.querySelectorAll('input'), function (i) { i.checked = i.value === ST.staerd; });
          tengja(el, function (x) { ST.staerd = x.value; ctx.breytt(); });
        },
        gildi: function () { return heitiStaerd(ST.staerd) + ', ' + malStaerdar(ST.staerd); },
        buid: function () { return !!ST.staerd; }
      },
      texti: {
        teikna: function (el, s, ctx) {
          smidaTexta(el, ctx);
          var ni = el.querySelector('[data-bm-texti="nafn"]'), Tm = T(), L = Tm && Tm.letur && Tm.letur.nafn;
          if (ni && L) {
            ni.style.fontFamily = "'" + (({"Dancing Script":"SM Skrift","IBM Plex Mono":"SM Mono"})[L.family] || L.family) + "', " + (/script|garamond/i.test(L.family) ? 'serif' : 'sans-serif');
            ni.style.fontWeight = L.weight || 400; ni.style.fontStyle = L.style === 'italic' ? 'italic' : 'normal';
            ni.style.textTransform = L.caps ? 'uppercase' : 'none';
          }
        },
        gildi: function () { return trim(ST.nafn); },
        buid: function (s) { return !!trim(ST.nafn) && !stoppar(s).length; },
        fokus: function (el, kodi) {
          var k = kodi === 'titill_of_langur' ? 'titill' : 'nafn';
          return el.querySelector('[data-bm-texti="' + k + '"]');
        }
      },
      lt: {
        teikna: function (el, s, ctx) {
          var lm = munur(s, { lt: 'ekkert' }, { lt: 'logo' }), la = finna(val(s, { lt: 'logo' }));
          var h = ctx.html.kostir({ nafn: 'vs-' + ctx.id + '-lt', dalkar: 3, kostir: [
            { gildi: 'ekkert', heiti: t('ekkert'), valid: ST.lt === 'ekkert' },
            { gildi: 'takn', heiti: t('takn'), valid: ST.lt === 'takn' },
            { gildi: 'logo', heiti: t('logo'), undir: lm ? munurKr(lm) : '', valid: ST.lt === 'logo', ovirkt: !la || la.til === false, ekki: !la }] });
          if (ST.lt === 'takn') {
            var E = B();
            h += '<p class="vs-hjalp" id="vs-' + ctx.id + '-bm-takn">' + esc(t('veldu_takn')) + '</p>' + ctx.html.kostir({ nafn: 'vs-' + ctx.id + '-takn', birting: 'spjold', dalkar: 5, klasi: 'vs-barmmerki-takn', merki: t('veldu_takn'),
              kostir: Object.keys((E && E.TAKN_HEITI) || {}).map(function (k) { return { gildi: k, heiti: heitiTakn(k), mynd: taknSvg(k), valid: ST.takn === k }; }) });
          }
          if (ST.lt === 'logo' && ST.logoSkb) h += '<p class="vs-hjalp vs-barmmerki-logostada" aria-live="polite">' + esc(ST.logoSkb) + '</p>';
          ctx.html.setja(el, h);
          tengja(el, function (x) {
            if (x.name === 'vs-' + ctx.id + '-lt') ST.lt = x.value; else ST.takn = x.value;
            ctx.breytt();
          });
        },
        gildi: function (s) {
          var lm = munur(s, { lt: 'ekkert' }, { lt: 'logo' });
          return ST.lt === 'takn' ? (ST.takn ? t('takn') + ': ' + heitiTakn(ST.takn) : t('takn')) : ST.lt === 'logo' ? t('logo') + (lm ? ' (' + munurKr(lm) + ')' : '') : t('ekkert');
        },
        buid: function () { return ST.lt !== 'takn' || !!ST.takn; }
      },
      festing: {
        teikna: function (el, s, ctx) {
          var k = ['engin', 'naela', 'segull'].map(function (f) {
            var m = munur(s, { festing: 'engin' }, { festing: f }), a = finna(val(s, { festing: f }));
            return { gildi: f, heiti: heitiFesting(f), undir: m ? munurKr(m) : '', valid: ST.festing === f, ovirkt: !a || a.til === false, ekki: !a };
          });
          ctx.html.setja(el, ctx.html.kostir({ nafn: 'vs-' + ctx.id + '-festing', dalkar: 3, kostir: k }));
          tengja(el, function (x) { ST.festing = x.value; ctx.breytt(); });
        },
        gildi: function (s) { var m = munur(s, { festing: 'engin' }, { festing: ST.festing }); return heitiFesting(ST.festing) + (m ? ' (' + munurKr(m) + ')' : ''); },
        buid: function () { return true; }
      }
    }
  };
  function r3(n) { return Math.round(n * 1000) / 1000; }
  /* the kit's state of the page for the tip buttons (they are drawn from vandamal, which has no state) */
  function stadaFyrir() {
    var p = window.SMVelSida && window.SMVelSida.sidur, i;
    if (p) for (i = 0; i < p.length; i++) if (p[i].rot === CTX.rot && typeof p[i].stada === 'function') return p[i].stada();
    return { kodar: CTX && CTX.afbrigdi ? CTX.afbrigdi.o : [], rammi: CTX ? CTX.rammiGildi() : '' };
  }
  if (window.SMVelSida) window.SMVelSida.skra('barmmerki', A);
  else (window.SMVelSidaBid = window.SMVelSidaBid || []).push(['barmmerki', A]);
})();
